import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RichTextEditor from 'react-rte';
import { CreateChancel, MultipleCheckBox } from 'components';
import RichTextEditorExample from './noteTextEditor';
import { noteStyles } from './styles';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, loadActions } from 'store';
import { authService } from '../../../../store/loads/loads.service';
import { FindLoad, FindSuccessItem, useModal } from 'utils';

const GET_LOAD_BY_CUSTOMERS = 'GET_LOAD_BY_CUSTOMERS';

export const AddReceivableNotes = ({ item, searchValue }) => {

  const [customerLoads, setCustomerLoads] = useState([]);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const { customersList } = useSelector((state) => ({
    customersList: state.customers.customersList,
  }));
  const dispatch = useDispatch();
  const { close } = useModal();
  const ACTION_TYPE = inputs?.id ? 'EDIT_RECEIVABLES_NOTE' : 'CREATE_RECEIVABLES_NOTE';
  const success = FindSuccessItem(ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);
  const loadLoads = FindLoad(GET_LOAD_BY_CUSTOMERS);
  const classes = noteStyles();

  useEffect(() => {
    if (item) {
      const params = {
        ...item,
      };

      params.note = RichTextEditor.createValueFromString(item?.note, 'html');
      getCustomerLoad(item?.customers?.map((customer) => customer.id));
      setInputs(params);
    }
  }, [item]);


  useEffect(() => {
    if (success?.type === ACTION_TYPE) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      close();
    }
  }, [success]);

  const getCustomerLoad = (ids) => {
    dispatch(httpRequestsOnLoadActions.appendLoading(GET_LOAD_BY_CUSTOMERS));
    authService.getLoadBYCustomers(ids).then((res) => {
      setCustomerLoads(res?.data);
    }).catch(() => {
      setCustomerLoads([]);
    }).finally(() => {
      dispatch(httpRequestsOnLoadActions.removeLoading(GET_LOAD_BY_CUSTOMERS));
    });
  };

  const handleSelect = (value, name) => {
    setInputs(prevState => ({ ...prevState, [name]: value }));
    if (name === 'customers') {
      const newParams = {
        ...inputs,
      };

      if (value?.length) {
        const ids = value.map((item) => item.id);
        getCustomerLoad(ids);
        newParams.customers = value;
        delete newParams.loads;
        setInputs(newParams);
      } else {
        setCustomerLoads([]);
        delete newParams.loads;
        delete newParams.customers;
        setInputs(newParams);
      }
    }
    if (error === name) {
      setError('');
    }
  };


  const handleSubmit = () => {
    if (inputs?.loads?.length && inputs?.customers?.length && inputs?.note) {

      const loads = inputs?.loads?.map((item) => item.id);
      const customers = inputs?.customers?.map((item) => item.id);

      const noteData = {
        note: inputs?.note?.toString('html'),
        loads: loads,
        customers: customers,
      };

      if (item?.id) {
        const editParams = {
          ...inputs,
        };
        editParams.note = inputs?.note?.toString('html');

        const sendParams = {};
        searchValue ? sendParams.searchKey = searchValue : delete sendParams.searchKey;
        dispatch(loadActions.editRecNote(inputs?.id, noteData, sendParams));
      } else {
        dispatch(loadActions.createRecNote(noteData));
      }
    } else {
      setError(
        !inputs?.customers?.length ? 'customers' :
          !inputs?.loads?.length ? 'loads' :
            !inputs?.note ? 'note' : '',
      );
    }
  };

  const handleCancel = () => {
    setError('');
    setInputs({});
    close();
  };

  return (
    <div className='note-modal-wrapper'>
      <div className='receivables-note-header'>
        <p className={classes.noteModalTitle}>
          {item ? 'Edit Note' : 'New Note'}
        </p>
      </div>

      <div className={classes.noteModalBox}>
        <div className={classes.noteSelectsRichText}>
          <div className='note-subject-box'>
            <div className='align-center' style={{ gap: 16 }}>
              <MultipleCheckBox
                limitTags={3}
                stylesWrapper={{width:'50%'}}
                handleChange={(e) => handleSelect(e, 'customers')}
                name='customers'
                renderValue={(item) => item?.name}
                value={inputs?.customers ? inputs?.customers : []}
                permissionsList={customersList?.customers || []}
                label={'Choose Customer*'}
                // placeholder={inputs?.customers?.length ? inputs?.customers?.map((i) => i?.name).join(', ') : 'All'}
                // uiType={'tableFilter'}
                typeError={error === 'customers'}
              />

              <MultipleCheckBox
                limitTags={3}

                stylesWrapper={{width:'50%'}}
                loadType={GET_LOAD_BY_CUSTOMERS}
                handleChange={(e) => handleSelect(e, 'loads')}
                name='loads'
                renderValue={(item) => item?.displayId}
                value={inputs?.loads ? inputs?.loads : []}
                permissionsList={customerLoads || []}
                label={'Load ID*'}
                // placeholder={inputs?.loads?.length ? inputs?.loads?.map((i) => i?.displayId).join(', ') : 'All'}
                // uiType={'tableFilter'}
                disabled={loadLoads?.length}
                typeError={error === 'loads'}
              />
            </div>
            <div style={{ marginTop: '-20px' }}>
              <RichTextEditorExample
                setInputs={setInputs}
                inputs={inputs}
                error={error === 'note'}
                setError={setError}
              />
            </div>
          </div>
          <div className='flex-end'>
            <CreateChancel
              loader={!!loader.length}
              create={'Save'}
              chancel={'Cancel'}
              onCreate={handleSubmit}
              onClose={handleCancel}
              width='93px'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

